import api from '@/API';
import repository from '../client-repository';

export async function hasAgreedTerms(clientId: number): Promise<boolean> {
  return repository.find(clientId).then(c => c.agreedTermsAt !== null);
}

export function agreeTerms(clientId: number): Promise<void> {
  return api.put(`clients/${clientId}/agree-terms`);
}
